import IconSubmittals from '@/assets/svgs/submittals-icon.svg?react'
import { NavigationLink } from '@/components/NavigationLink'
import SubmittalsNavGroup from '@/components/Navigation/SubmittalsNavGroup'
import useFeature, { features } from '@/hooks/useFeature'
import { getDexConfig } from '@/utils/getDexConfig'
import { getEnvAndDex } from '@/utils/getEnvAndDex'

export const Navigation = () => {
  const { dex } = getEnvAndDex()
  const { LogoComponent: Logo } = getDexConfig(dex)

  // Today's single link, and what the group falls back to when there is no
  // second data element to choose between.
  const submittalsLink = (
    <NavigationLink to="/submittals" icon={<IconSubmittals />} text="Submittals" />
  )

  return (
    <div>
      <div className="flex items-center justify-center pt-9.25 type-body-2 text-[1rem] [&_svg]:w-[140px] [&_svg]:h-[54px]">
        <Logo />
        <span className="text-grey-50 pl-2"></span>
      </div>
      <div className="mt-12.75">
        <div className="-mt-4">
          <div className="mt-2.5 first:mt-0">
            {/* The flag is read here rather than inside the group so that with it
                off nothing mounts the data element config chain, which every page
                would otherwise pay for. */}
            {useFeature(features.SUBMITTALS_PHASE_2) ? (
              <SubmittalsNavGroup fallback={submittalsLink} />
            ) : (
              submittalsLink
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
